module.exports = __webpack_public_path__ + "static/img/logo_lianmeng.40c385a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_lianmeng.png
// module id = TUe0
// module chunks = 14